import React from "react";
import { Routes, Route } from "react-router-dom";

//Layouts
import Header from "../layouts/header";
//Pages
import HomePage from "../pages/homePage";
import Login from "../pages/login";
import Gallery from "../pages/gallery";
import AgencyTemplates from "../pages/agencyTemplates";
import Profile from "../pages/profile";
import Register from "../pages/register";
import ConfirmationEmail from "../pages/register/confirmationEmail";
import ConfirmationSuccess from "../pages/register/confirmationSuccess";
import RecoverPassword from "../pages/recoverPassword";
import EmailSend from "../pages/recoverPassword/emailSend";
import NewPassword from "../pages/recoverPassword/newPassword";
import ChangeSuccess from "../pages/recoverPassword/changeSuccess";
import UserList from "../pages/userList";
import UserDetail from "../pages/userDetail";
import EmployeesPage from "../pages/employees";
import RegistrationForm from "../pages/registrationForm/index";
import EducationalMaterial from "../pages/educationalMaterial/index";
import Unauthorized from "../pages/errorPages/unauthorized";
import CoursesPage from "../pages/courses";
import Page404 from "../pages/errorPages/404";
import Page500 from "../pages/errorPages/500";
import HomePageWW from "../pages/homePageWW";
import Reports from "../pages/reports";

//Constants
import ProtectedRoute from "./protectedRoutes";
import { RoleEnum } from "../constants/enum";

const WordWideWT = () => {
  return (
    <div className="main-div">
      <Routes>
        <Route
          path="/home"
          element={
            <ProtectedRoute
              path="/home"
              role={[RoleEnum.agency, RoleEnum.admin, RoleEnum.traveler]}
            >
              <Header />
              <HomePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/gallery"
          element={
            <ProtectedRoute
              path="/gallery"
              role={[RoleEnum.agency, RoleEnum.admin, RoleEnum.traveler]}
            >
              <Header />
              <Gallery />
            </ProtectedRoute>
          }
        />
        <Route
          path="/templates"
          element={
            <ProtectedRoute
              path="/home"
              role={[RoleEnum.agency, RoleEnum.admin, RoleEnum.traveler]}
            >
              <Header />
              <AgencyTemplates />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employers"
          element={
            <ProtectedRoute
              path="/employers"
              role={[RoleEnum.agency, RoleEnum.admin]}
            >
              <Header />
              <EmployeesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses"
          element={
            <ProtectedRoute
              path="/courses"
              role={[RoleEnum.admin, RoleEnum.agency]}
            >
              <Header />
              <CoursesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute
              path="/reports"
              role={[RoleEnum.admin, RoleEnum.agency]}
            >
              <Header />
              <Reports />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<HomePageWW />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/profile"
          element={
            <ProtectedRoute
              path="/profile"
              role={[RoleEnum.agency, RoleEnum.admin, RoleEnum.traveler]}
            >
              <Header />
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-list"
          element={
            <ProtectedRoute
              path="/user-list"
              role={[RoleEnum.agency, RoleEnum.admin]}
            >
              <Header />
              <UserList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-list/user-detail/:idUser"
          element={
            <ProtectedRoute
              path="/user-list/user-detail/:idUser"
              role={[RoleEnum.agency, RoleEnum.admin]}
            >
              <Header />
              <UserDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/registration-form"
          element={
            <>
              <Header />
              <RegistrationForm />
            </>
          }
        />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/registration-form" element={<RegistrationForm />} />
        <Route path="/educational-material" element={<EducationalMaterial />} />
        <Route path="/register" element={<Register />} />
        <Route path="/register-success" element={<ConfirmationEmail />} />
        <Route path="/recover-password" element={<RecoverPassword />} />
        <Route path="/recover-password/email-sent" element={<EmailSend />} />
        <Route path="/email-confirmation" element={<ConfirmationSuccess />} />
        <Route path="/recover-password/success" element={<ChangeSuccess />} />
        <Route path="/new-password" element={<NewPassword />} />
        <Route path="/500" element={<Page500 />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
    </div>
  );
};

export default WordWideWT;
